import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/close.svg'
import _imports_1 from '@/assets/ok2.svg'
import _imports_2 from '@/assets/upload-instructions/pl/idOk1.png'
import _imports_3 from '@/assets/upload-instructions/en/idOk1.png'
import _imports_4 from '@/assets/bad.svg'
import _imports_5 from '@/assets/upload-instructions/pl/idBad1.png'
import _imports_6 from '@/assets/upload-instructions/en/idBad1.png'
import _imports_7 from '@/assets/upload-instructions/pl/idBad2.png'
import _imports_8 from '@/assets/upload-instructions/en/idBad2.png'
import _imports_9 from '@/assets/upload-instructions/pl/idBad3.png'
import _imports_10 from '@/assets/upload-instructions/en/idBad3.png'


const _withScopeId = n => (_pushScopeId("data-v-ec5cc408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "instructions" }
const _hoisted_2 = { class: "instructions__top-container" }
const _hoisted_3 = { class: "instructions__close-btn" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "ok",
  class: "instructions__icon"
}, null, -1))
const _hoisted_5 = { class: "instructions__text-ok" }
const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_8 = { class: "instructions__bad-examples" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "ok",
  class: "instructions__icon"
}, null, -1))
const _hoisted_10 = { class: "instructions__text-bad" }
const _hoisted_11 = {
  ref: "swiper",
  class: "swiper-container"
}
const _hoisted_12 = { class: "swiper-wrapper" }
const _hoisted_13 = { class: "swiper-slide" }
const _hoisted_14 = {
  key: 0,
  src: _imports_5,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_6,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_16 = { class: "slide-title" }
const _hoisted_17 = { class: "slide-text" }
const _hoisted_18 = { class: "swiper-slide" }
const _hoisted_19 = {
  key: 0,
  src: _imports_7,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_20 = {
  key: 1,
  src: _imports_8,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_21 = { class: "slide-title" }
const _hoisted_22 = { class: "slide-text" }
const _hoisted_23 = { class: "swiper-slide" }
const _hoisted_24 = {
  key: 0,
  src: _imports_9,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_25 = {
  key: 1,
  src: _imports_10,
  alt: "ok",
  class: "instructions__example"
}
const _hoisted_26 = { class: "slide-title" }
const _hoisted_27 = { class: "slide-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClosePopup && _ctx.handleClosePopup(...args)))
        })
      ]),
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.goodExample`)), 1),
      (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : (_openBlock(), _createElementBlock("img", _hoisted_7))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.badExample`)), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : (_openBlock(), _createElementBlock("img", _hoisted_15)),
              _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideTitle1`)), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideText1`)), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
                ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                : (_openBlock(), _createElementBlock("img", _hoisted_20)),
              _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideTitle2`)), 1),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideText2`)), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.UtilityHelper.getLocale() == _ctx.Locale.PL)
                ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                : (_openBlock(), _createElementBlock("img", _hoisted_25)),
              _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideTitle3`)), 1),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.slideText3`)), 1)
            ])
          ]),
          _hoisted_28
        ], 512)
      ])
    ])
  ]))
}